// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2NnOQ","rootSuccess":"CompleteLink_rootSuccess__MmfhT","rootFailure":"CompleteLink_rootFailure__2bEyb","isDisabled":"CompleteLink_isDisabled__2KLrH"};